import { Form as AntdForm } from 'antd';
import { Field, getIn } from 'formik';
import type { FormItemProps } from './types';

export const FormItem = ({
  name,
  showValidateSuccess,
  showInitialErrorAfterTouched = false,
  children,
  validate,
  ...restProps
}: FormItemProps) => {
  if (!name) {
    return <AntdForm.Item {...restProps}>{children}</AntdForm.Item>;
  }

  return (
    <Field name={name} validate={validate}>
      {({ form: { errors = {}, touched = {}, initialErrors = {} } }) => {
        const error = getIn(errors, name, undefined);
        const initialError = getIn(initialErrors, name, undefined);
        let isTouched = getIn(touched, name, false);

        if (Array.isArray(isTouched)) {
          isTouched = isTouched.length === 0 ? true : isTouched.some(Boolean);
        }

        const hasError = error !== undefined && isTouched;
        const hasInitialError = initialError !== undefined;
        const isValid = !error && isTouched;
        const showHelp = hasError || (hasInitialError && (!isTouched || showInitialErrorAfterTouched));

        return (
          <AntdForm.Item
            htmlFor={name}
            id={name}
            validateStatus={
              hasError || (hasInitialError && !isTouched)
                ? 'error'
                : isValid && showValidateSuccess
                  ? 'success'
                  : undefined
            }
            hasFeedback={isValid && showValidateSuccess}
            help={
              showHelp ? (
                <>
                  {hasError && <li>{error}</li>}
                  {hasInitialError && (!isTouched || showInitialErrorAfterTouched) && <li>{initialError}</li>}
                </>
              ) : null
            }
            {...restProps}
          >
            {children}
          </AntdForm.Item>
        );
      }}
    </Field>
  );
};

export default FormItem;
